module.exports = __webpack_public_path__ + "img/PS-M-3.7db31071.svg";